import { render, staticRenderFns } from "./whOrderCancel.vue?vue&type=template&id=6a1049cc&scoped=true&"
import script from "./whOrderCancel.vue?vue&type=script&lang=js&"
export * from "./whOrderCancel.vue?vue&type=script&lang=js&"
import style0 from "./whOrderCancel.vue?vue&type=style&index=0&id=6a1049cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1049cc",
  null
  
)

export default component.exports